<div class="editor-header">
  <div class="editor-heading">
    <div class="editor-heading-title">
      <mat-icon>volunteer_activism</mat-icon>
      <span>{{ isEditMode ? 'Corregir nombramiento' : 'Nuevo nombramiento' }}</span>
    </div>
    <p>{{ isEditMode ? 'Corregí los datos del nombramiento seleccionado.' : 'Agrega un nuevo nombramiento para este miembro.' }}</p>
  </div>
</div>

<div class="event-summary-layout">
  <div class="events-summary">
    <div class="events-summary__title">Nombramientos registrados</div>
    <table class="events-summary__table">
      <thead>
        <tr>
          <th>Desde</th>
          <th>Hasta</th>
          <th>Nombramiento</th>
          <th>Unidad</th>
          <th>Lugar del acto</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let event of visibleAssignmentEvents" [class.events-summary__row--current]="!event.endDate">
          <td>{{ formatDate(event.eventDate) }}</td>
          <td>{{ event.endDate ? formatDate(event.endDate) : '-' }}</td>
          <td>{{ event.eventTypeName }}</td>
          <td>{{ event.organizationUnitName || '-' }}</td>
          <td>{{ event.location || '-' }}</td>
        </tr>
        <tr *ngIf="!visibleAssignmentEvents.length" class="events-summary__empty">
          <td colspan="5">Sin nombramientos registrados</td>
        </tr>
      </tbody>
    </table>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="editor-form">
  <div class="form-grid">
    <app-date-picker label="Fecha de inicio" formControlName="validFrom"></app-date-picker>

    <app-optional-field
      [formControls]="form.get('validTo')!"
      triggerLabel="Agregar fecha de finalización"
      removeTooltip="Quitar fecha de finalización">
      <app-date-picker label="Fecha de finalización" formControlName="validTo"></app-date-picker>
    </app-optional-field>

    <mat-form-field>
      <mat-label>Nombramiento</mat-label>
      <mat-select formControlName="assignmentId" (selectionChange)="onAssignmentChange()">
        <mat-option *ngFor="let option of assignments" [value]="option.id">
          {{ option.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('assignmentId')?.hasError('required')">Requerido</mat-error>
    </mat-form-field>

    <app-unit-selector
      class="field-full"
      [defaultUnitName]="defaultUnitName"
      [unitSource]="'all'"
      [allowedLevelIds]="selectedAssignmentAllowedLevelIds"
      [allowDefaultUnit]="true"
      [groupByLevel]="true"
      groupByMode="level"
      formControlName="organizationUnitId">
    </app-unit-selector>

    <mat-form-field *ngIf="mustChooseMembershipCommunity" class="field-full">
      <mat-label>Comunidad de pertenencia</mat-label>
      <mat-select formControlName="membershipCommunityId" required>
        <mat-option *ngFor="let community of membershipCommunityOptions" [value]="community.id">{{ community.name }}</mat-option>
      </mat-select>
      <mat-hint>Elegí dónde mantiene su pertenencia. Si seleccionás otra comunidad, se registrará el pase en la fecha efectiva.</mat-hint>
    </mat-form-field>

    <div *ngIf="!isActPlaceVisible" class="field-full optional-field-trigger">
      <button mat-button type="button" (click)="onAddActPlace()">
        <mat-icon>add</mat-icon>
        Agregar lugar del acto
      </button>
    </div>

    <div *ngIf="isActPlaceVisible" class="field-full act-place-block">
      <div class="act-place-header">
        <label class="act-place-label">Lugar del acto</label>
        <button mat-icon-button type="button" (click)="onRemoveActPlace()" title="Quitar lugar del acto">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-radio-group formControlName="actPlaceMode" class="act-place-mode">
        <mat-radio-button value="community">Comunidad</mat-radio-button>
        <mat-radio-button value="location">Otro lugar</mat-radio-button>
      </mat-radio-group>

      <app-unit-selector
        *ngIf="actPlaceMode === 'community'"
        class="field-full"
        label="Comunidad del acto"
        [required]="true"
        [unitSource]="'all'"
        [levelId]="5"
        [groupByLevel]="true"
        groupByMode="ancestors"
        formControlName="actOrganizationUnitId">
      </app-unit-selector>

      <mat-form-field *ngIf="actPlaceMode === 'location'" class="field-full">
        <mat-label>Lugar</mat-label>
        <input matInput formControlName="actLocation" />
        <mat-error *ngIf="form.get('actLocation')?.hasError('required')">Requerido</mat-error>
        <mat-error *ngIf="form.get('actLocation')?.hasError('maxlength')">Máximo 200 caracteres</mat-error>
      </mat-form-field>
    </div>
  </div>

  <p class="form-hint" *ngIf="!selectedAssignmentHasLevels">
    Este nombramiento no tiene niveles organizativos configurados.
  </p>

  <div class="form-actions">
    <button mat-button type="button" (click)="onCancel()">Cancelar</button>
    <button mat-flat-button color="primary" type="submit" [disabled]="isSaving || !selectedAssignmentHasLevels">
      <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon>
      <span *ngIf="!isSaving">Guardar</span>
      <span *ngIf="isSaving">Guardando...</span>
    </button>
  </div>
  </form>
</div>
